import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { BaseState, createCRUDModel, createCRUDStates } from '../creator';
import { RootState } from '../index';
import listSaga from './list';
import updateSaga from './update';
import byIdSaga from './byId';
import { PaginatedResponse } from '../types';
import { Seo } from '../../types/seo';
import { IFaq } from '../../types/faq';
import { IImage } from '../../types/image';

export const moduleName = 'usaState';

export interface IUsaState {
  id: number,
  name: string,
  code: string,
  description: string | null,
  tipCreditAllowed: boolean,
  zipPrefix: string | null,
  minimumWageBeforeTips: boolean,
  countryId: number | null,
  faqs: IFaq[] | null,
  seo: Seo | null,
  slug: string,
  isSeoReady: boolean,
  image: IImage | null
}

export interface IUsaStateShort {
  id: number;
  name: string;
  slug: string;
  code: string;
  isSeoReady: boolean;
}

export interface State {
  list: BaseState<PaginatedResponse<IUsaStateShort>>,
  byId: BaseState<IUsaState>,
  update: BaseState< {
    success: boolean,
    message: string,
    messages: string[],
    error: string
  }>,
}

const models = ['list', 'byId', 'update'];

export const defaultState: State = createCRUDStates<State>(models);

export const usaState = createSlice({
  name: moduleName,
  initialState: defaultState,
  reducers: createCRUDModel(models, moduleName),
});

export const { actions } = usaState;

export function useUsaState(): State {
  return useSelector((state: RootState) => state[moduleName]);
}

export function* saga() {
  yield* listSaga();
  yield* updateSaga();
  yield* byIdSaga();
}
